



<template>
    <div class="sticky z-10 top-[70px] sm:top-[80px] flex bg-gray-100 dark:bg-neutral-800 dark:bg-opacity-75 dark:backdrop-blur-xl text-gray-500 dark:text-white pb-4 pt-4 px-6 justify-between shadow-md">
        <Teleport to="body">
            <filtermenu></filtermenu>
        </Teleport>
        <div class="flex text-gray-500 dark:text-white space-x-3 text-sm">
            <template v-if="filtersVisible() && showButton">
                <span v-if="showFilterModal" @click="showFilterModal()" :set="activeFilters = filtersVisible()"
                class="relative text-left flex items-center md:hidden">
                    {{ activeFilters }}
                    {{ $tc('Filter', activeFilters) }} {{ $t('active') }}
                </span>
            </template>
            <div v-else-if="showButton" @click="showFilterModal()"
                class="rounded-full flex justify-between items-center border-gray-400 text-gray-400 dark:text-white border border-dashed px-4 py-1 cursor-pointer hover:bg-white md:hidden">
                <span class="cursor-pointer">+ {{ $t('Add filter') }}</span>
            </div>
            <span v-if="showFilterModal && showButton" @click="showFilterModal()" class="relative text-left items-center hidden md:flex">
                {{ $t('Filters') }}
            </span>
            <span v-if="showButton" class="relative text-left items-center hidden md:flex">
                |
            </span>
            <div class="hidden md:flex items-center space-x-1 ">
                <!-- <div
    class="rounded-full flex justify-between items-center bg-white border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100"
    v-for="(item, key) in search" v-if="item[1] && item[1] != 0">
    <span>{{ item[1] }} {{ item[0] }}</span>
    <svg class="h-3 w-3 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        @click="clearFilter(item[0])" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
    </div> -->
                <div v-if="checkin && checkout" @click.self="switchToCalendar"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700 border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span @click.self="switchToCalendar">{{ formatDate(checkin) }} - {{ formatDate(checkout) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="cleardate()" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div v-if="search.get('city')"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700  border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span>{{ $t(search.get('city')) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="clearFilter('city'); removeCookie('searchlocation'); ; VueCookies.remove('city')" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div v-if="search.get('country')"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700  border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span>{{ $t(search.get('country')) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="clearFilter('country'); removeCookie('searchlocation'); ; VueCookies.remove('country')" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div v-if="search.get('state')"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700  border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span>{{ $t(search.get('state')) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="clearFilter('state'); removeCookie('searchlocation'); ; VueCookies.remove('state')" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div v-if="search.get('numAdult')"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700  border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span>{{ search.get('numAdult') }} {{ $tc('Adult', search.get('numAdult')) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="clearFilter('numAdult')" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <div v-if="search.get('numChildren') && search.get('numChildren') != 0"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700  border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span>{{ search.get('numChildren') }} {{ $tc('Child', search.get('numChildren')) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="clearFilter('numChildren')" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div v-if="search.get('proptypes')" v-for="(item, index) in getPropertyTypes()"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700  border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span>{{ getPropTypeName($t(item)) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="removePropType(item)" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div v-if="search.get('features')" v-for="(item, index) in getFeatures()"
                    class="rounded-full flex justify-between items-center bg-white dark:bg-neutral-700  border-gray-500 border pl-4 pr-2 py-1 cursor-pointer hover:bg-gray-100">
                    <span>{{ $t(item) }}</span>
                    <svg class="h-3 w-3 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" @click="removeFeature(item)" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div v-if="showButton" @click="showFilterModal()"
                    class="rounded-full flex justify-between items-center border-gray-400 text-gray-400 border border-dashed px-4 py-1 cursor-pointer hover:bg-white">
                    <span class="cursor-pointer">+ {{ $t('Add filter') }}</span>
                </div>
            </div>
        </div>

        <div class="flex items-center">
            <AppDropdown
                toggleclasses="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-white">
                <template slot="toggler">
                    {{ $t('Sort') }}
                </template>
                <AppDropdownContent>
                    <AppDropdownItem code="popu">{{ $t('Most Popular') }}</AppDropdownItem>
                    <!-- <AppDropdownItem code="scor">{{ $t('Best Rating') }}</AppDropdownItem> -->
                    <AppDropdownItem code="news">{{ $t('Newest') }}</AppDropdownItem>
                    <AppDropdownItem code="plth">{{ $t('Price: Low to High') }}</AppDropdownItem>
                    <AppDropdownItem code="phtl">{{ $t('Price: High to Low') }}</AppDropdownItem>
                </AppDropdownContent>
            </AppDropdown>

            
            <button v-if="showButton" @click="showFilterModal()" type="button"
                class="-m-2 ml-4 p-2 text-gray-400 dark:text-white hover:text-gray-500 sm:ml-6 md:hidden">
                <span class="sr-only">{{ $t('Filters') }}</span>
                <svg class="h-5 w-5" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z"
                        clip-rule="evenodd" />
                </svg>
            </button>
        </div>
    </div>
</template>


<script>

import moment from "moment";
import VueCookies from 'vue-cookies'

import { Modal } from 'flowbite'

import Teleport from 'vue2-teleport';

import filters from '../../data/filters.json'

import AppDropdown from "./dropdown/AppDropdown.vue";
import AppDropdownContent from "./dropdown/AppDropdownContent.vue";
import AppDropdownItem from "./dropdown/AppDropdownItem.vue";

export default {
    name: 'filterbar',
    props: ['currentView', 'showButton'],
    components: {
        // "vue-load-image": VueLoadImage,
        Teleport,
        AppDropdown,
        AppDropdownContent,
        AppDropdownItem
    },
    data() {
        return {
            search: new URLSearchParams(window.location.search),
            filterModal: null,
            checkin: null,
            checkout: null,
        }
    },
    methods: {
        goToMap() {
            VueCookies.set('listertype', 'map');
            var urlString = window.location.href;
            var url = new URL(urlString);
            window.location.href = url.origin + '/accomodations/map' + url.search;
        },
        switchToCalendar() {
            this.$root.$emit("showCalendarSearch", true);
        },
        filtersVisible() {
            if (
                this.getFeatures() ||
                this.getPropertyTypes() ||
                this.search.get('location') ||
                this.search.get('country') ||
                (this.search.get('numAdult') && this.search.get('numAdult') != 0) ||
                (this.search.get('numChildren') && this.search.get('numChildren') != 0)
            ) {

                var total = 0;
                total += this.getFeatures() ? this.getFeatures().length : 0;
                total += this.getPropertyTypes() ? this.getPropertyTypes().length : 0;

                return total + this.search.has('location') +
                    this.search.has('country') +
                    (this.search.has('checkin') && this.search.has('checkout')) +
                    (this.search.has('numAdult') && this.search.get('numAdult') != 0) +
                    (this.search.has('numChildren') && this.search.get('numChildren') != 0)
            } else {
                return 0;
            }
        },
        showFilterModal() {
            this.filterModal.show();
        },
        goToGrid() {
            VueCookies.set('listertype', 'grid');
            var urlString = window.location.href;
            var url = new URL(urlString);
            window.location.href = url.origin + '/accomodations' + url.search;
        },

        formatDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD').locale(this.$i18n.locale).format('Do MMM');
        },
        getFeatures() {
            return this.search.get('features') ? this.search.get('features').split(',') : null
        },
        getPropertyTypes() {
            return this.search.get('proptypes') ? this.search.get('proptypes').split(',') : null
        },
        getPropTypeName(item) {
            return this.$t(filters['accommodationTypes'][item])
        },
        removeFeature(feature) {
            if (this.search.get('features')) {
                var features = this.search.get('features').split(",")
                features = jQuery.grep(features, function (val) {
                    return val != feature;
                });
                this.search.set("features", features.join(","))
                window.location.search = this.search;
            }
        },
        removePropType(proptype) {
            if (this.search.get('proptypes')) {
                var proptypes = this.search.get('proptypes').split(",")
                proptypes = jQuery.grep(proptypes, function (val) {
                    return val != proptype;
                });
                this.search.set("proptypes", proptypes.join(","))
                window.location.search = this.search;
            }
        },
        clearFilter(item) {
            history.replaceState(null, null, ' ');
            var urlString = window.location.href;
            var url = new URL(urlString);
            url.searchParams.delete(item)
            VueCookies.remove(item)
            window.location.href = url;
        },
        removeCookie(item) {
            VueCookies.remove(item);
        },
        cleardate() {
            var urlString = window.location.href;
            var url = new URL(urlString);
            url.searchParams.delete('checkin')
            url.searchParams.delete('checkout')
            VueCookies.remove('checkin')
            VueCookies.remove('checkout')
            window.location.href = url;
        },
    },
    mounted() {

        const $modalElement = document.querySelector('#filters-modal');

        const modalOptions = {
            placement: 'bottom-right',
            backdrop: 'dynamic',
            backdropClasses: 'bg-black/50 fixed inset-0 z-40 max-w-[100vw]',
            onHide: () => {
                $("body").removeClass("scroll_lock")
            },
            onShow: () => {
                $("body").addClass("scroll_lock")
            }
        }
        this.filterModal = new Modal($modalElement, modalOptions);
    },
    created() {
        if (this.search.get('checkin')) {
            this.checkin = this.search.get('checkin');
            VueCookies.set('checkin', this.search.get('checkin'));
        } else if (VueCookies.get('checkin')) {
            this.checkin = VueCookies.get('checkin');
            this.search.append('checkin', VueCookies.get('checkin'));
        }

        if (this.search.get('checkout')) {
            this.checkout = this.search.get('checkout');
            VueCookies.set('checkout', this.search.get('checkout'));
        } else if (VueCookies.get('checkout')) {
            this.checkout = VueCookies.get('checkout');
            this.search.append('checkout', VueCookies.get('checkout'));
        }
    }
}
</script>